import { render, staticRenderFns } from "./rebuttalDisplay.vue?vue&type=template&id=8753a814&scoped=true&"
import script from "./rebuttalDisplay.vue?vue&type=script&lang=js&"
export * from "./rebuttalDisplay.vue?vue&type=script&lang=js&"
import style0 from "./rebuttalDisplay.vue?vue&type=style&index=0&id=8753a814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8753a814",
  null
  
)

export default component.exports